import { useCallback } from "react";
import { useNavigate, type NavigateOptions, type To } from "react-router-dom";
import { localizePath } from "@/lib/localizedPaths";
import { useLanguage } from "@/lib/translation";

/**
 * Localizes a link target for the active language: a string path to a public page
 * gets the language prefix ("/pricing" becomes "/pt/pricing" in Portuguese); app
 * paths and non string targets pass through.
 */
export function useLocalizePath() {
  const language = useLanguage();
  return useCallback(
    (to: To): To => (typeof to === "string" ? localizePath(to, language) : to),
    [language],
  );
}

/** useNavigate, with public paths localized like LocalizedLink's Link. */
export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const localize = useLocalizePath();
  return useCallback(
    (to: string, options?: NavigateOptions) => navigate(localize(to), options),
    [navigate, localize],
  );
}
